<template>
 <div class="col-md-12 mr-auto ml-auto">
  <div class="wizard-container">
   <div class="card card-wizard active" data-color="primary">
    <Form @submit="onSubmit" :validation-schema="schema">
     <div class="card-body">
      <div class="row">
       <BarraBotoes
        :loadingSave="loadingSave"
        :idRegistroCarregado="$route.params.id"
        :key="keyRV"
        :gridViewLink="'/patrimonio/patbem'"
        @limpar="limparFormulario"
        @excluir="excluir"
       />

       <div class="container-fluid">
        <AccordionSection
         title="Identificação"
         :defaultOpen="true"
         targetId="collapseIdentificacao"
         iconClass="bi bi-person-badge"
        >
         <div class="row">
          <div class="col-3 mb-3">
           <div class="form-group">
            <label>Código</label>
            <Field name="codigo" class="form-control" type="text" v-model="model.codigo" />
            <ErrorMessage name="codigo" />
           </div>
          </div>

          <div class="col-3 mb-3">
           <div class="form-group">
            <label>Quantidade</label>
            <Field name="quantidade" class="form-control" type="text" v-model="model.quantidade" />
            <ErrorMessage name="quantidade" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <label>Descrição</label>
            <Field name="descricao" class="form-control" type="text" v-model="model.descricao" />
            <ErrorMessage name="descricao" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <label>Observação</label>
            <Field
             name="observacao"
             as="textarea"
             class="form-control"
             rows="4"
             v-model="model.observacao"
            />
            <ErrorMessage name="observacao" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <DropDownListTipoBem
             :key="`tipo-bem-${formKey}-${model.patTipoBemId ?? 'novo'}`"
             v-model="model.patTipoBemId"
            />
            <ErrorMessage name="patTipoBemId" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <DropDownListPatFormaTombamento
             :key="`forma-tombamento-${formKey}-${model.patFormaTombamentoId ?? 'novo'}`"
             v-model="model.patFormaTombamentoId"
            />
            <ErrorMessage name="patFormaTombamentoId" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <DropDownListPatEstadoConservacao
             :key="`estado-conservacao-${formKey}-${model.patEstadoConservacaoId ?? 'novo'}`"
             v-model="model.patEstadoConservacaoId"
            />
            <ErrorMessage name="patEstadoConservacaoId" />
           </div>
          </div>
         </div>
        </AccordionSection>

        <AccordionSection
         title="Localização"
         :defaultOpen="false"
         targetId="collapsePublicacao"
         iconClass="bi bi-person-badge"
        >
         <div class="row">
          <div class="col-10 mb-3">
           <div class="form-group">
            <DropDownListSala
             :key="`sala-${formKey}-${model.gesSalaId ?? 'novo'}`"
             v-model="model.gesSalaId"
            />
            <ErrorMessage name="gesSalaId" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <label>Localização</label>
            <Field name="localizacao" class="form-control" type="text" v-model="model.localizacao" />
            <ErrorMessage name="localizacao" />
           </div>
          </div>

          <div class="col-10 mb-3">
           <div class="form-group">
            <label>Unidade de Guarda</label>
            <Field name="unidadeGuarda" class="form-control" type="text" v-model="model.unidadeGuarda" />
            <ErrorMessage name="unidadeGuarda" />
           </div>
          </div>
         </div>
        </AccordionSection>

        <AccordionSection
         title="Aquisição"
         :defaultOpen="false"
         targetId="collapseAquisicao"
         iconClass="bi bi-person-badge"
        >
         <div class="row">
          <div class="col-3 mb-3">
           <div class="form-group">
            <label>Data de Aquisição</label>
            <Field name="dataAquisicao" class="form-control" type="date" v-model="model.dataAquisicao" />
            <ErrorMessage name="dataAquisicao" />
           </div>
          </div>

          <div class="col-3 mb-3">
           <div class="form-group">
            <label>Valor Aquisição</label>
            <Field name="valorAquisicao" class="form-control" type="text" v-model="model.valorAquisicao" />
            <ErrorMessage name="valorAquisicao" />
           </div>
          </div>

          <div class="col-3 mb-3">
           <div class="form-group">
            <label>Nota Fiscal</label>
            <Field name="notaFiscal" class="form-control" type="text" v-model="model.notaFiscal" />
            <ErrorMessage name="notaFiscal" />
           </div>
          </div>

          <div class="col-12 mb-3">
           <div class="form-group">
            <label>Forma de Aquisição</label>
            <div class="d-flex gap-3 pt-2">
             <div class="form-check">
              <input
               id="formaAquisicaoCompra"
               v-model="model.formaAquisicao"
               class="form-check-input"
               type="radio"
               name="formaAquisicao"
               :value="0"
              />
              <label for="formaAquisicaoCompra" class="form-check-label">Compra</label>
             </div>
             <div class="form-check">
              <input
               id="formaAquisicaoDoacao"
               v-model="model.formaAquisicao"
               class="form-check-input"
               type="radio"
               name="formaAquisicao"
               :value="1"
              />
              <label for="formaAquisicaoDoacao" class="form-check-label">Doação</label>
             </div>
            </div>
            <ErrorMessage name="formaAquisicao" />
           </div>
          </div>

          <div v-if="Number(model.formaAquisicao) === 1" class="col-10 mb-3">
           <div class="form-group">
            <label>Termo de Doação</label>
            <Field name="termoDoacao" class="form-control" type="text" v-model="model.termoDoacao" />
            <ErrorMessage name="termoDoacao" />
           </div>
          </div>

          <div v-if="Number(model.formaAquisicao) === 0" class="col-10 mb-3">
           <div class="form-group">
            <DropDownListFornecedor v-model="model.gesFornecedorId" :tipoFornecedor="1" />
            <ErrorMessage name="gesFornecedorId" />
           </div>
          </div>

          <div class="col-12 mt-3">
           <div class="card">
            <div class="card-header">
              <h5 class="mb-0">Depreciação</h5>
            </div>
            <div class="card-body">
             <div class="row">
              <div class="col-3 mb-3">
               <div class="form-group">
                <label>Vida Útil</label>
                <Field name="vidaUtil" class="form-control" type="text" v-model="model.vidaUtil" />
                <ErrorMessage name="vidaUtil" />
               </div>
              </div>

              <div class="col-3 mb-3">
               <div class="form-group">
                <label>Valor Residual</label>
                <Field name="valorResidual" class="form-control" type="text" v-model="model.valorResidual" />
                <ErrorMessage name="valorResidual" />
               </div>
              </div>
             </div>
            </div>
           </div>
          </div>
         </div>
        </AccordionSection>

        <AccordionSection
         title="Baixa"
         :defaultOpen="false"
         targetId="collapseBaixa"
         iconClass="bi bi-person-badge"
        >
         <div class="row">
          <div class="col-3 mb-3">
           <div class="form-check mt-4">
            <input
             id="situacao"
             v-model="model.situacao"
             class="form-check-input"
             type="checkbox"
             :true-value="1"
             :false-value="0"
             @change="onChangeSituacao"
            />
            <label for="situacao" class="form-check-label">Baixado</label>
           </div>
           <ErrorMessage name="situacao" />
          </div>

          <div v-if="Number(model.situacao) === 1" class="col-3 mb-3">
           <div class="form-group">
            <label>Data Baixa</label>
            <Field name="dataBaixa" class="form-control" type="date" v-model="model.dataBaixa" />
            <ErrorMessage name="dataBaixa" />
           </div>
          </div>

          <div v-if="Number(model.situacao) === 1" class="col-10 mb-3">
           <div class="form-group">
            <DropDownListPatMotivoBaixa
             :key="`motivo-baixa-${formKey}-${model.patMotivoBaixaId ?? 'novo'}`"
             v-model="model.patMotivoBaixaId"
            />
            <ErrorMessage name="patMotivoBaixaId" />
           </div>
          </div>

          <div v-if="Number(model.situacao) === 1" class="col-10 mb-3">
           <div class="form-group">
            <label>Observação da Baixa</label>
            <Field
             name="motivoBaixa"
             as="textarea"
             class="form-control"
             rows="4"
             v-model="model.motivoBaixa"
            />
            <ErrorMessage name="motivoBaixa" />
           </div>
          </div>
         </div>
        </AccordionSection>
       </div>
      </div>
     </div>
    </Form>
   </div>
  </div>
 </div>
</template>

<script lang="ts">
import { Form, Field, ErrorMessage } from "vee-validate";
import { PatBemModel } from "@/models/patrimonio/patbem/patbem.model";
import PatBemService from "@/services/patrimonio/patbem/patbem.service";
import * as yup from "yup";
import { defineComponent } from "vue";
import toastService from "@/services/globals/toast.service";
import BarraBotoes from "@/components/formulario/BarraBotoes.vue";
import DropDownListTipoBem from "@/components/formulario/patrimonio/DropDownListPatTipoBem.vue";
import DropDownListPatFormaTombamento from "@/components/formulario/patrimonio/DropDownListPatFormaTombamento.vue";
import DropDownListPatEstadoConservacao from "@/components/formulario/patrimonio/DropDownListPatEstadoConservacao.vue";
import DropDownListPatMotivoBaixa from "@/components/formulario/patrimonio/DropDownListPatMotivoBaixa.vue";
import DropDownListSala from "@/components/formulario/gestao/DropDownListSala.vue";
import DropDownListFornecedor from "@/components/formulario/gestao/DropDownListFornecedor.vue";
import AccordionSection from "@/components/accordionsection/accordionSection.vue";

export default defineComponent({
 name: "InclusaoEdicao",
 components: {
  BarraBotoes,
  Form,
  Field,
  ErrorMessage,
  DropDownListTipoBem,
  DropDownListPatFormaTombamento,
  DropDownListPatEstadoConservacao,
  DropDownListPatMotivoBaixa,
  DropDownListSala,
  DropDownListFornecedor,
  AccordionSection,
 },

 data() {
  return {
   schema: yup.object({
    patTipoBemId: yup.number().label("PatTipoBemId"),
    codigo: yup.string().max(10).label("Codigo"),
    descricao: yup.string().max(50).label("Descricao"),
    dataAquisicao: yup.date().label("DataAquisicao"),
    valorAquisicao: yup.number().label("ValorAquisicao"),
    notaFiscal: yup.string().max(10).label("NotaFiscal"),
    patEstadoConservacaoId: yup.number().label("PatEstadoConservacaoId"),
    patFormaTombamentoId: yup.number().label("PatFormaTombamentoId"),
    unidadeGuarda: yup.string().max(30).label("UnidadeGuarda"),
    vidaUtil: yup.number().label("VidaUtil"),
    tipoBem: yup.number().label("TipoBem"),
    quantidade: yup.number().label("Quantidade"),
    formaAquisicao: yup.number().label("Forma de Aquisição"),
    gesFornecedorId: yup.number().label("GesFornecedorId"),
    gesEscolaId: yup.number().label("GesEscolaId"),
    gesSalaId: yup.number().label("GesSalaId"),
    localizacao: yup.string().max(100).label("Localizacao"),
    situacao: yup.number().label("Situacao"),
    dataBaixa: yup.date().label("DataBaixa"),
    patMotivoBaixaId: yup.number().label("PatMotivoBaixaId"),
    motivoBaixa: yup.string().max(1000).label("Observação da Baixa"),
    termoDoacao: yup.string().max(30).label("TermoDoacao"),
    estadoConservacao: yup.number().label("Descricao"),
    valorResidual: yup.number().label("ValorResidual"),
    observacao: yup.string().max(4000).label("Observacao"),
   }),
   model: new PatBemModel() as PatBemModel,
   stopSubmit: false,
   loadingSave: false,
   keyRV: 0 as number,
   formKey: 0 as number,
  };
 },

 methods: {
  formatDateForInput(value: unknown) {
   if (!value) return undefined;
   if (typeof value === "string") {
    return value.length >= 10 ? value.substring(0, 10) : value;
   }
   if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
   }
   return undefined;
  },

  onChangeSituacao() {
   if (Number(this.model.situacao) !== 1) {
    this.model.dataBaixa = undefined;
    this.model.patMotivoBaixaId = 0;
    this.model.motivoBaixa = "";
   }
  },

  reload() {
   this.keyRV += 1;
   this.formKey += 1;
  },

  limparFormulario() {
   this.model = new PatBemModel();
   this.reload();
   this.reloadRoute();
  },

  reloadRoute(idRegistro: number | null = null) {
   if (idRegistro) {
    this.$router.replace({
     name: "patbem_create",
     params: { id: idRegistro },
    });
   } else {
    this.$router.replace({
     name: "patbem_create",
    });
   }
  },

  carregarFormulario() {
   if (this.$route.params.id) {
    PatBemService.get(this.$route.params.id).then((x) => {
     this.model = x;
     this.model.dataAquisicao = this.formatDateForInput(this.model.dataAquisicao) as unknown as Date;
     this.model.dataBaixa = this.formatDateForInput(this.model.dataBaixa) as unknown as Date;
     this.formKey += 1;
    });
   }
  },

  excluir() {
   if (this.$route.params.id) {
    PatBemService.remover(this.$route.params.id).then(() => {
     this.limparFormulario();
     toastService.alertaSucesso("Registro excluÃ­do com sucesso!");
    });
   }
  },

  onSubmit() {
   if (this.$route.params.id) {
    this.model.patBemId = Number(this.$route.params.id);
   }

   this.loadingSave = true;

   PatBemService.inserirAtualizar(this.model)
    .then((x) => {
     toastService.alertaSucesso("Dados registrados com sucesso!");
     this.reloadRoute(x.data.codigo);
    })
    .catch((error) => {
     console.error("Erro ao salvar PatBem:", error);
     toastService.alertaErro("Ocorreu um erro ao executar a ação.");
    })
    .finally(() => {
     this.loadingSave = false;
    });
  },
 },

 mounted() {
  this.carregarFormulario();
 },

 watch: {
  "$route.params.id": {
   handler() {
    this.keyRV += 1;
    this.formKey += 1;
    this.carregarFormulario();
   },
   immediate: true,
  },
 },
});
</script>
